import { Timestamp } from 'firebase/firestore'

interface RenewalBannerProps {
    subscriptionEnd: Timestamp | null
    plan: string
    onRenewClick: () => void
}

export function RenewalBanner({ subscriptionEnd, plan, onRenewClick }: RenewalBannerProps) {
    if (plan !== 'premium' || !subscriptionEnd) return null

    const now = new Date()
    const expiryDate = subscriptionEnd.toDate()
    const diffTime = expiryDate.getTime() - now.getTime()
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))

    // Show only within last 7 days (or if expired but status is still premium for some reason)
    if (diffDays > 7) return null

    const isExpired = diffDays <= 0

    return (
        <div className={`w-full px-4 py-3 text-center text-sm font-medium ${isExpired ? 'bg-red-100 text-red-800' : 'bg-yellow-100 text-yellow-800'
            }`}>
            {isExpired ? (
                <>
                    ⚠️ Your subscription has expired.
                    <button onClick={onRenewClick} className="ml-2 underline hover:text-red-900">
                        Renew Now
                    </button>
                </>
            ) : (
                <>
                    ⚠️ Your subscription expires in {diffDays} day{diffDays !== 1 ? 's' : ''}.
                    <button onClick={onRenewClick} className="ml-2 underline hover:text-yellow-900">
                        Renew to avoid interruption
                    </button>
                </>
            )}
        </div>
    )
}
